import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, Backdrop, Box, CircularProgress, Container, Snackbar } from "@mui/material";
import { getFiltrarPromociones, postDeletePromocion } from "../../../api/ApiService";
import { useNavigate } from "react-router-dom";
import PromocionesHeader from "./components/PromocionesHeader";
import PromocionesFiltrosComponents from "./components/PromocionesFiltrosComponents";
import PromocionesTableComponent from "./components/PromocionesTableComponent";
import ModalDeletePromocion from "./components/ModalDeletePromocion";



export const statusOptions = [
    { label: 'Vigentes', value: "vigentes", id: 1 },
    { label: 'Inactivos', value: "inactivos", id: 2 },
    { label: 'Todos', value: "todos", id: 3 },
];





function PromocionesAppPage() {
    const [nameCedula, setNameCedula] = useState('');
    const [estado, setEstado] = useState('');
    const [estadoSelected, setEstadoSelected] = useState(null);
    const [loading, setLoading] = useState(false);
    const [dataPromociones, setDataPromociones] = useState([]);
    const [loadingCargar, setLoadingCargar] = useState(false);

    const [loadingDeletePromocion, setLoadingDeletePromocion] = useState(false);
    const [showDeletePromocionModal, setShowDeletePromocionModal] = useState(false);
    const [idPromocionDelete, setIdPromocionDelete] = useState(null);

    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');


    const [perPage, setPerPage] = useState(10);
    const [metaPaginacion, setMetaPaginacion] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
    });

    const [statusFilter, setStatusFilter] = useState("todos");
    const [searchFilter, setSearchFilter] = useState("");






    const stateToken = useSelector(state => state.reducerGlobal.token);

    let history = useNavigate();


    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (searchFilter.length > 2) {

                handleApiFiltrarPromocionesTituloEstado(searchFilter, statusFilter);
            } else {
                // handleApiFiltrarEventos(1);
                handleApiFiltrarPromociones(1);
            }
        }, 1500);
        return () => clearTimeout(timeOutId);
    }, [stateToken, searchFilter, statusFilter, perPage]);






















    // Funciones para manejar el modal
    const handleAddPromocion = () => {
        history('/app/admin/promociones/agregar');
    };







    // funcion para manejar el input de busqueda
    const handleSearchChange = (value) => {
        setSearchFilter(value);
    };


    // funcion para manejar el cambio en el filtro de estado
    const handleStatusChange = (value) => {
        setStatusFilter(value);
    };



    // funcion para manejar el cambio en la cantidad por página
    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
        // Reiniciar a la primera página cuando cambie la cantidad
        // handleApiFiltrarPromociones(1);

    };








    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarPromocionesTituloEstado = (titulo, estado) => {

        let body = {
            page: 1,
            per_page: perPage,
            estado: estado,
            titulo: titulo
        };
        console.log("body-handleApiFiltrarLocales", body);


        setLoadingCargar(true);

        getFiltrarPromociones(stateToken?.access_token, body)
            .then(response => {
                console.log("response==>getFiltrarPromociones", response);
                setLoadingCargar(false);

                if (response.data.length > 0) {
                    setDataPromociones(response.data);
                    setLoading(true);
                } else {
                    setDataPromociones([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.meta?.current_page,
                    per_page: response?.meta?.per_page,
                    total: response?.meta?.total,
                    last_page: response?.meta?.last_page
                });


            })
            .catch(error => {
                console.log("error==>getFiltrarPromociones", error);
                setDataPromociones([]);
                setLoading(true);
                setLoadingCargar(false);
            })
    };



    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarPromociones = (page = 1) => {

        let body = {
            page: page,
            per_page: perPage,
            estado: statusFilter,
            titulo: searchFilter
        };
        // console.log("body-handleApiFiltrarLocales", body);


        setLoadingCargar(true);

        getFiltrarPromociones(stateToken?.access_token, body)
            .then(response => {
                // console.log("response==>getFiltrarPromociones", response);

                setLoadingCargar(false);
                // setMetaPaginacion(response.meta);

                if (response.data.length > 0) {
                    setDataPromociones(response.data);
                    setLoading(true);
                } else {
                    setDataPromociones([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.meta?.current_page,
                    per_page: response?.meta?.per_page,
                    total: response?.meta?.total,
                    last_page: response?.meta?.last_page
                });


            })
            .catch(error => {
                console.log("error==>getFiltrarPromociones", error);
                setDataPromociones([]);
                setLoading(true);
                setLoadingCargar(false);
            })
    };






    const handleEditarItem = (item) => {
        // console.log("item a editar==>", item);

        // history(`/app/admin/evento-detalle/${usuario.id}`);
        history(`/app/admin/promocion/detalle/${item?.id}?mode=editar`);

    };





    const handleOpenModalDeletePromocion = (idPromo) => {

        setIdPromocionDelete(idPromo);
        setShowDeletePromocionModal(true);
    };

    const handleCloseModalDeletePromocion = () => {
        setIdPromocionDelete(null);
        setShowDeletePromocionModal(false);
    };

    const openAlert = (type, text) => {
        setSeverity(type);
        setMensaje(text);
        setOpen(true);
    };

    const handleCloseAlert = () => {
        setOpen(false);
    };

    const handleDeletePromocion = () => {
        if (!idPromocionDelete) return;

        if (!stateToken?.access_token) {
            openAlert("error", "No se encontró token de autenticación.");
            return;
        }

        setLoadingDeletePromocion(true);

        postDeletePromocion(idPromocionDelete, stateToken.access_token)
            .then(() => {
                openAlert("success", "Promoción eliminada con éxito.");
                handleCloseModalDeletePromocion();
                handleApiFiltrarPromociones(1);
            })
            .catch(() => {
                openAlert("error", "Error al eliminar la promoción.");
            })
            .finally(() => {
                setLoadingDeletePromocion(false);
            });
    }


    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-6">
                {loading ? (
                    <div className="max-w-7xl mx-auto">


                        <PromocionesHeader
                            title="Promociones"
                            subtitle="Administra y supervisa las promociones de la plataforma."
                            handleAdd={handleAddPromocion}
                        />

                        <div>
                            <PromocionesFiltrosComponents
                                searchValue={searchFilter}
                                onSearchChange={handleSearchChange}
                                statusFilter={statusFilter}
                                onStatusChange={handleStatusChange}
                                statusOptions={statusOptions}
                            />

                            <PromocionesTableComponent
                                data={dataPromociones}
                                metaPaginacion={metaPaginacion}
                                onPageChange={handleApiFiltrarPromociones}
                                perPage={perPage}
                                onPerPageChange={handlePerPageChange}
                                handleEditarItem={handleEditarItem}
                                handleOpenModalDelete={handleOpenModalDeletePromocion}
                            />


                        </div>
                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-md p-8">
                        <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                        <div className="space-y-4">
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-24 bg-gray-200 rounded animate-pulse" />
                        </div>
                    </div>
                )}


                <ModalDeletePromocion
                    openModal={showDeletePromocionModal}
                    loading={loadingDeletePromocion}
                    handleCloseModal={handleCloseModalDeletePromocion}
                    handleDelete={handleDeletePromocion}
                />

                <Backdrop open={loadingCargar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>

                <Snackbar open={open} autoHideDuration={2000} onClose={handleCloseAlert}>
                    <Alert onClose={handleCloseAlert} severity={severity} elevation={6} variant="filled" >
                        {mensaje}
                    </Alert>
                </Snackbar>

            </div>
        </HeaderCustom>
    );
}
export default PromocionesAppPage;